import React from "react";
import "./pages.css";
import { PROJECT_DISPLAY_NAME } from "../../../config/apiConfig";

export default function TermsofUseNew() {
  return (
    <div>
      <section className="tac_wrapper mt-4">
        <div className="container">
          <div className="acc_main_head">
            <div className="row">
              <div className="col-md-10 pt-2">
                <h1>MARKETSANDMARKETS {PROJECT_DISPLAY_NAME} TERMS OF USE</h1>
              </div>
            </div>
          </div>

          <p className="para">
            This MarketsandMarkets {PROJECT_DISPLAY_NAME} Terms of Use document details the
            terms of a legal agreement (the "Terms of Use") between “You” or
            “User” and MarketsandMarkets Research Private Limited (“MnM”) and
            Third Party Provider’s as defined in this document. By accessing or
            using this platform, or any platform or mobile application or
            Services within the Platform referring to these Terms of Use as its
            terms (the "Platform;) , or any Services (as defined below), you
            acknowledge and irrevocably represent that you have read and
            understood the Terms of Use, and you voluntarily and irrevocably
            accept and agree to be bound by the Terms of Use. You also agree to
            comply with all laws and regulations applicable to the use of this
            Platform, the use of the internet, and the activities involved in
            using this Platform.{" "}
          </p>

          <p className="para">
            If you do not agree with these Terms of Use, do not use this
            Platform. If you, or the entity through which you were provided a
            log-in ID and password, subscribed to certain content or services
            found on this Platform by way of executing a written agreement, in
            the form of an addendum, order form, Subscription Agreement, Trial
            Agreement or otherwise ("Agreement"), then these Terms of Use shall
            be supplemental to such Agreement, and use of this Platform is
            subject to the terms of the Agreement in addition to these Terms of
            Use. By accessing this Platform, you acknowledge that you have read
            and are bound by the Agreement (if you require a copy of the
            Agreement, please contact your company's contract administrator).
          </p>

          <ol className="para">
            <li className="list_ol">
              <strong>Definitions:</strong>
              <p className="para">
                {" "}
                “Services” MnM's information products, data, services, software,
                software as a service, application or technology management
                services, technology systems, applications, reports, files and
                documentation identified and further defined in the applicable
                Agreement including the Content defined herein this Terms of Use
                document. <br />
              </p>
            </li>
            <li className="list_ol">
              <strong>License:</strong>
              <p className="para">
                {" "}
                You acquire absolutely no rights or licenses in or to this
                Platform, Services and any text, graphics, user interfaces,
                visual interfaces, photographs, trademarks, logos, sounds,
                music, audio, video, artwork, computer code, information, data
                and material therein, including ratings or scores (collectively,
                the "Content") other than the limited right to access and view,
                and to utilize this Platform and Services for your own personal,
                internal, non-commercial purposes, in accordance with these
                Terms of Use and terms of Agreement. We may revoke this license
                at any time for any or no reason by terminating your
                subscription to the Services. You may not sell or publicly
                display or distribute any MnM Content or otherwise use the MnM
                Content in a manner not expressly permitted in these Terms of
                Use without MnM’s prior written consent.
              </p>
            </li>
            <li className="list_ol">
              <strong>General Restrictions on Use:</strong>

              <p className="para">
                You will not in connection with your use of this Platform and
                Services therein: (a) violate any applicable local, state,
                national or international law, statute, ordinance, rule or
                regulation, including without limitation those relating to
                competition, antitrust, economic sanctions, or export controls;
                (b) interfere with or disrupt the computer networks of MnM or
                attempt to do so; (c) download, upload, post, transmit, publish,
                or distribute any material that infringes, violates, breaches or
                otherwise contravenes the rights of MnM, Third Party Provider or
                any third party, including any copyright, trademark, patent,
                rights of privacy or publicity or any other proprietary right;
                (e) interfere with or disrupt the use of this Platform by any
                other customer or user or reverse look-up, trace or seek to
                trace any information on any other user of or visitor to this
                Platform, or any other customer of MnM, including any MnM
                account not owned by you; (f) probe, scan or test the
                vulnerability of this Platform or any network connected to this
                Platform or attempt to gain unauthorized entry or access to the
                computer systems of any other person or entity.
              </p>
              <p className="para">
                You may not use any linking, deep-linking, framing or
                page-scraping technology, robots, spiders or other automatic
                devices, programs, algorithms or methodologies, or any similar
                or equivalent manual processes, to access, acquire, copy,
                distribute, display or monitor any portion of this Platform or
                Services, or in any way reproduce or circumvent the navigational
                structure or presentation of this Platform or Services to obtain
                or attempt to obtain any materials, documents or information
                through any means not purposely made available through this
                Platform.
              </p>
              <p className="para">
                Unless otherwise provided in the Agreement, you hereby agree and
                acknowledge that you are expressly prohibited from: (i) making
                available all or any portion of the Services to any other person
                or entity, except as expressly permitted in these Terms of Use
                or in an Agreement; (ii) creating derivative works from the
                Services; and (iii) using the Services in the provision of any
                services to third parties. In addition, you shall not
                distribute, transfer, sub-license, rent, lend, transmit, sell,
                re-circulate, repackage, assign, lease, resell, publish, copy,
                translate, convert, decompile, reverse engineer, alter, enhance,
                disassemble, modify, or change all or any portion of the
                Services.
              </p>
            </li>

            <li className="list_ol">
              <strong>Intellectual Property Ownership:</strong>
              <p className="para">
                The ownership and intellectual property rights of this Platform
                including all Services, Content, models, software, information,
                data, documentation, computer programs, systems, customizations,
                enhancements thereto, and the design, structure, selection,
                coordination, expression "look and feel" and arrangement of the
                Content, and enhancements, modifications or additional Content
                thereto shall be the sole and exclusive property of MnM (or the
                Third Party Provider (as defined in this agreement), as the case
                may be) and you shall not: (i) copy such material for any
                purpose (including by reverse engineering) or disclose it to any
                third party for any purpose whatsoever; (ii) by act or omission
                infringe upon MnM's intellectual property rights in this
                Platform or Services. You acknowledge that this Platform, was
                developed, compiled, prepared, revised, selected and arranged by
                MnM and others (including Third Party Provider information
                sources) through the application of methods and standards of
                judgment developed and applied through the expenditure of
                substantial time, effort and money, and constitute valuable
                intellectual property and trade secrets of MnM or such relevant
                Third Party Provider.
              </p>
              <p className="para">
                The Services contains MnM intellectual property and that of
                other third parties and is protected by U.S. and international
                copyright law and other intellectual property laws. Unauthorized
                reproduction or distribution of the Services or Content, in
                whole or in part, without our express written consent, may
                result in civil and criminal penalties, and may be prosecuted to
                the maximum extent possible under law. The publication or
                dissemination of any Content or the Services, without our
                express, written consent is prohibited and may result in
                termination of your rights to use or access the Services. Unless
                otherwise explicitly stated in these Terms of use, we do not
                provide you with any right to our intellectual property rights,
                or those of a third party, whether by estoppel, implication,
                waiver or otherwise, and all rights are hereby reserved by MnM.
              </p>
              <p className="para">
                You agree not to modify, alter, remove, or deface any of the
                trademarks, service marks or other intellectual property made
                available by us in connection with the Services. You agree not
                to use any MnM Content for any purpose other than the permitted
                purposes in accordance with these Terms of Use. You agree not to
                defame or disparage us, our trademarks or service marks, or any
                aspect of the Services. Unless otherwise specifically agreed in
                writing by MnM, you agree not to adapt, translate, modify,
                decompile, disassemble, copy, create derivative works of, or
                reverse engineer the Services or any software or programs used
                in connection with the Services.
              </p>
            </li>
            <li className="list_ol">
              <strong>Privacy Policy:</strong>

              <p className="para">
                You understand, acknowledge, and agree that the operation of
                certain features of the Content may require or involve the
                provision, use, and dissemination of various items of personally
                identifiable information, including without limitation personal
                contact information. For information related to how MnM
                processes personal information or uses cookies and similar
                technologies, please visit our 
                <a href="https://www.marketsandmarkets.com/Privacy-12.html">
                  https://www.marketsandmarkets.com/Privacy-12.html
                </a>{" "}
                 pages.
              </p>
            </li>
            <li className="list_ol">
              <strong>Log-in:</strong>
              <p className="para">
                You acknowledge that log-on access codes and passwords that are
                provided to you are for your use only and may not be shared. You
                shall ensure that your log-on access code and password is kept
                confidential. You agree to accept sole responsibility for the
                use and protection of the log-on access codes and passwords
                provided to you, including protecting the confidentiality of
                such passwords. You shall use commercially reasonable efforts to
                prohibit or cease any unauthorized access to this Platform or
                Services.
              </p>
            </li>
            <li className="list_ol">
              <strong>
                Disclaimer of Warranties and Limitation of Liability:
              </strong>

              <p className="para">
                THIS PLATFORM AND SERVICES PROVIDED TO YOU BY MARKETSANDMARKETS
                SHALL BE ON "AS IS" BASIS. NEITHER MARKETSANDMARKETS , ITS
                AFFILIATES NOR ANY THIRD PARTY PROVIDER MAKE ANY WARRANTY,
                EXPRESS OR IMPLIED, AS TO THE ACCURACY, TIMELINESS OR
                COMPLETENESS OF THIS PLATFORM OR SERVICES OR AS TO THE RESULTS
                TO BE ATTAINED BY YOU OR OTHERS FROM THE USE OF THE SERVICES.
                YOU HEREBY ACKNOWLEDGE THAT THERE ARE NO EXPRESS OR IMPLIED
                WARRANTIES OF TITLE, MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                PURPOSE OR USE, AND THAT IT HAS NOT RELIED UPON ANY WARRANTY,
                GUARANTY OR REPRESENTATION MADE BY MARKETSANDMARKETS, ITS
                AFFILIATES OR ANY THIRD PARTY PROVIDER, EXCEPT THE
                REPRESENTATIONS MADE BY MARKETSANDMARKETS SPECIFICALLY SET FORTH
                IN THIS TERMS OF USE.
              </p>
              <p className="para">
                <strong> NO LIABILITY.</strong>
                NEITHER MARKETSANDMARKETS, ITS AFFILIATES NOR ANY THIRD PARTY
                PROVIDER SHALL IN ANY WAY BE LIABLE TO YOU OR ANY CLIENT OF YOU
                FOR ANY INACCURACIES, ERRORS OR OMISSIONS, REGARDLESS OF CAUSE,
                IN THE SERVICES PROVIDED HEREUNDER OR FOR ANY DAMAGES (WHETHER
                DIRECT OR INDIRECT) RESULTING THEREFROM. WITHOUT LIMITING THE
                FOREGOING, MARKETSANDMARKETS SHALL HAVE NO LIABILITY WHATSOEVER
                TO YOU, WHETHER IN CONTRACT (INCLUDING UNDER AN INDEMNITY), IN
                TORT (INCLUDING NEGLIGENCE), UNDER A WARRANTY, UNDER STATUTE OR
                OTHERWISE, IN RESPECT OF ANY LOSS OR DAMAGE SUFFERED BY YOU AS A
                RESULT OF OR IN CONNECTION WITH ANY OPINIONS, RECOMMENDATIONS,
                FORECASTS, JUDGMENTS, OR ANY OTHER CONCLUSIONS, OR ANY COURSE OF
                ACTION DETERMINED, BY YOU OR ANY CLIENT OF YOU, WHETHER OR NOT
                BASED ON THIS PLATFORM OR SERVICES.
              </p>
              <p className="para">
                TO THE FULLEST EXTENT PERMITTED BY LAW, UNDER NO CIRCUMSTANCES
                WILL MARKETSANDMARKETS, ITS AFFILIATES OR ANY THIRD PARTY
                PROVIDER HAVE ANY LIABILITY TO YOU OR ANY THIRD PARTY ACCESSING
                THIS PLATFORM AND/ OR THE SERVICES THROUGH YOU, ARISING FROM
                CONTRACT (INCLUDING UNDER ANY INDEMNITY), IN TORT (INCLUDING
                NEGLIGENCE), UNDER ANY WARRANTY (EXPRESS OR IMPLIED) UNDER
                STATUTE OR OTHERWISE, IN EACH CASE FOR ANY DIRECT, INDIRECT,
                INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY
                DAMAGES WITH RESPECT TO THE SUBJECT MATTER OF THE TERMS OF USE,
                THE CONTENT AND / OR THIS PLATFORM, INCLUDING, BUT NOT LIMITED
                TO, IN RESPECT OF ANY LOSS OF PROFITS, LOSS OF REVENUE, LOST
                BUSINESS, LOSS OF OPPORTUNITY REGARDLESS OF WHETHER SUCH DAMAGES
                COULD HAVE BEEN FORESEEN OR PREVENTED OR ADVISED TO
                MARKETSANDMARKETS.
              </p>
            </li>
            <li className="list_ol">
              <strong>Prohibited Uses</strong>

              <p className="pata">
                <strong>
                  You agree to use the Services professionally, ethically and
                  lawfully. You may not use the Services in any manner that:{" "}
                </strong>
                <ol type="a">
                  <li className="list_ol">
                    Is defamatory, unlawful, harassing, abusive, threatening,
                    obscene, hateful, sexist, or racially or ethnically
                    offensive;
                  </li>
                  <li className="list_ol">
                    Constitutes a breach of any person’s privacy or publicity
                    rights;
                  </li>
                  <li className="list_ol">
                    Violates any statute, regulation, or ordinance;
                  </li>
                  <li className="list_ol">
                    Promotes software or services that deliver unsolicited mail;
                    or{" "}
                  </li>
                  <li className="list_ol">
                    Promotes, encourages, or facilitates terrorism or other
                    activities that risk national security.{" "}
                  </li>
                </ol>
              </p>


                <strong>
                  You may not upload, post, communicate, or otherwise transmit
                  any information or other materials on or through the Services
                  that:{" "}
                </strong>
                <ol type="a">
                  <li className="list_ol">
                    Contain any viruses, Trojan horses, worms, cancel bots, time
                    bombs, spyware, or similar computer malicious code;
                  </li>
                  <li className="list_ol">
                    Is knowingly untrue, inaccurate, or misleading.
                  </li>
                  <li className="list_ol">
                    Violates U.S. law, Indian law or is obscene, obscene as to
                    minors, child pornography, defamatory, racist, lewd,
                    lascivious, filthy, excessively violent, harassing, or
                    otherwise objectionable; or
                  </li>
                  <li className="list_ol">
                    Damages or interferes with the operations of the Services or
                    with other users of the Services.
                  </li>
                </ol>
              </li>

                <strong>You further agree that you will not: </strong>
                <ol type="a">
                  <li className="list_ol">
                    Access the Services or obtain information therefrom in an
                    unauthorized manner.
                  </li>
                  <li className="list_ol">
                    Misuse passwords, MnM data, the Services, Third-Party
                    Provider’s services, or our systems or network;
                  </li>
                  <li className="list_ol">
                    Share, sell, distribute or otherwise transfer your Account
                    or allow your login credentials to be used by any other
                    individual.
                  </li>
                  <li className="list_ol">Impersonate any person or entity;</li>
                  <li className="list_ol">
                    Falsely state or otherwise misrepresent your affiliation
                    with a person or entity;
                  </li>
                  <li className="list_ol">
                    Use MnM data or content from the Services for any purpose
                    inconsistent with the purpose of the Services, any purpose
                    other than the permitted purposes or in violation of these
                    Terms;
                  </li>
                  <li className="list_ol">
                    Use hidden pages, images, or restricted access pages;
                  </li>
                  <li className="list_ol">
                    Use the Services in connection with surveys, contests,
                    pyramid schemes, chain letters, junk email, spam, or any
                    duplicative or unsolicited messages;
                  </li>
                  <li className="list_ol">
                    Use any automated procedure to gather information or data
                    from the Services by means of what is commonly called a
                    “bot” or otherwise;
                  </li>
                  <li className="list_ol">
                    Interfere with or disrupt the Services, servers, or networks
                    connected to the Services;
                  </li>
                  <li className="list_ol">
                    Integrate MnM and Third-Party Provider data into any
                    customer relationship management, marketing automation, or
                    sales enablement platform to allow unauthorized users to
                    access or use MnM or its Third-Party Provider data;
                  </li>
                  <li className="list_ol">
                    Breach or attempt to breach the security of software,
                    networks, servers, data, computers, or other hardware
                    relating to the Services (or that of any third party that is
                    hosting or interfacing with any part of the Services);
                  </li>
                  <li className="list_ol">
                    Create any frames at any other websites pertaining to or
                    using any of the information provided through the Services,
                    or promote bonus items, giveaways, random drawings,
                    contests, or prizes on the Services;
                  </li>
                  <li className="list_ol">
                    Duplicate, copy, or otherwise exploit the Services or
                    content therefrom for unauthorized commercial purposes; or
                  </li>
                  <li className="list_ol">
                    Violate the rights of third parties.{" "}
                  </li>
                </ol>


            <li className="list_ol">
              <strong>Submitted Data</strong>
              <p className="para">
                Trademarks. You shall not use any of MnM or Third-Party
                Provider's trademarks, trade names or service marks in any
                manner, and in no event in a manner accessible by or available
                to any third party. You acknowledge that you have no ownership
                or license rights in or to any of these names or marks.{" "}
              </p>
              <p className="para">
                Copyright: This Platform, Services and Content is protected as a
                collective work or compilation under India Copyright, UK
                copyright, U.S. copyright and other laws and treaties. All data,
                information, articles, columns and other elements making up the
                Services, Content are copyrighted works and MnM and Third-Party
                Provider’s hereby reserves all rights.{" "}
              </p>
              <p className="para">
                S&P Copyright Notice: With respect to the information, contents
                in the Services provided by S&P, S&P is the source of the
                Services and S&P reserves all the rights “Copyright © 2025, S&P
                Global Market Intelligence (and its affiliates as applicable).
                All rights reserved”.{" "}
              </p>
              <p className="para">
                S&P Copyright Disclaimer: Copyright © 2025, S&P Global Market
                Intelligence (and its affiliates as applicable). Reproduction of
                any information, opinions, views, data or material, including
                ratings (“Content”) in any form is prohibited except with the
                prior written permission of the relevant party. Such party, its
                affiliates and suppliers (“Content Providers”) do not guarantee
                the accuracy, adequacy, completeness, timeliness or availability
                of any Content and are not responsible for any errors or
                omissions (negligent or otherwise), regardless of the cause, or
                for the results obtained from the use of such Content. In no
                event shall Content Providers be liable for any damages, costs,
                expenses, legal fees, or losses (including lost income or lost
                profit and opportunity costs) in connection with any use of the
                Content. A reference to a particular investment or security, a
                rating or any observation concerning an investment that is part
                of the Content is not a recommendation to buy, sell or hold such
                investment or security, does not address the suitability of an
                investment or security and should not be relied on as investment
                advice. Credit ratings are statements of opinions and are not
                statements of fact.” Content defined in this clause is with
                respect to S&P.{" "}
              </p>
              <p className="para">
                MSCI Copyright Notice: S&P and MSCI are the source of the
                Service. The Global Industry Classification Standard (GICSâ) was
                developed by and/or is the exclusive property of MSCI, Inc. and
                S&P Global Market Intelligence Inc. (“S&P Global Market
                Intelligence”). GICS is a service mark of MSCI and S&P Global
                Market Intelligence and has been licensed for use by MnM.{" "}
              </p>
            </li>
			<li className="list_ol">
              <strong>Trademarks and Copy Right:</strong>
              <p className="para">
			  Trademarks. You shall not use any of MnM or Third-Party Provider's trademarks, trade names or service marks in any manner, and in no event in a manner accessible by or available to any third party. You acknowledge that you have no ownership or license rights in or to any of these names or marks. 
              </p>
			  <p className="para">
			  Copyright: This Platform, Services and Content  is protected as a collective work or compilation under India Copyright, UK copyright, U.S. copyright and other laws and treaties. All data, information, articles, columns and other elements making up the Services,  Content are copyrighted works and MnM and Third-Party Provider’s   hereby reserves all rights. 
              </p>
			  <p className="para">
			  S&P Copyright Notice: With respect to the  information, contents in the Services  provided by S&P, S&P is the source of the Services and S&P reserves all the rights  “Copyright © 2025, S&P Global Market Intelligence (and its affiliates as applicable). All rights reserved”.  
              </p>
			  <p className="para">
			  S&P Copyright Disclaimer:  Copyright © 2025, S&P Global Market Intelligence (and its affiliates as applicable). Reproduction of any information, opinions, views, data or material, including ratings (“Content”) in any form is prohibited except with the prior written permission of the relevant party. Such party, its affiliates and suppliers (“Content Providers”) do not guarantee the accuracy, adequacy, completeness, timeliness or availability of any Content and are not responsible for any errors or omissions (negligent or otherwise), regardless of the cause, or for the results obtained from the use of such Content. In no event shall Content Providers be liable for any damages, costs, expenses, legal fees, or losses (including lost income or lost profit and opportunity costs) in connection with any use of the Content. A reference to a particular investment or security, a rating or any observation concerning an investment that is part of the Content is not a recommendation to buy, sell or hold such investment or security, does not address the suitability of an investment or security and should not be relied on as investment advice. Credit ratings are statements of opinions and are not statements of fact.” Content defined in this clause is with respect to S&P. 
              </p>
			  <p className="para">
			  MSCI Copyright Notice: S&P and MSCI are the source of the Service. The Global Industry Classification Standard (GICSâ) was developed by and/or is the exclusive property of MSCI, Inc. and S&P Global Market Intelligence Inc. (“S&P Global Market Intelligence”). GICS is a service mark of MSCI and S&P Global Market Intelligence and has been licensed for use by MnM.  
              </p>
            </li>

            <li className="list_ol">
              <strong>Indemnification:</strong>
              <p className="para">
                You will indemnify, defend and hold harmless MnM and its
                affiliates, directors, officers, agents, employees, successors,
                assigns and all Third Party Provider’s, and each of their
                affiliates, directors, officers, agents, employees, members,
                partners, successors and assigns ("MnM Indemnitees") from and
                against any and all losses, liabilities, damages, costs
                (including reasonable attorneys' fees) and expenses arising as a
                result of any claims, suits or proceedings
                (collectively, "Claims") brought by any third party against any
                MnM Indemnitees arising from your use of this Platform and/or
                Services.
              </p>
            </li>

            <li className="list_ol">
              <strong>Links to Third Party Platforms:</strong>
              <p className="para">
                This Platform may contain links to third party websites,
                platforms, applications. These links are provided to you as a
                convenience, and MnM or Third-Party Provider is not responsible
                for the content of any linked websites, platforms, applications.
                In addition, a link to any non-MnM websites, platforms,
                applications does not imply that MnM endorses or accepts any
                responsibility for the content or use of such a websites,
                platforms, applications. “Third-Party Provider” means a supplier
                of data, information, software, services or other items that are
                part of or otherwise used in connection with the Services.
                Third-Party Provider’s includes but not limited to S&P and MSCI,
                Inc., For the purposes of this Terms of Use  “S&P” means S&P
                Global Market Intelligence LLC, S&P Global Inc., or any of S&P
                Global Inc.’s subsidiaries.
              </p>
            </li>

            <li className="list_ol">
              <strong>Violation of these Terms of Use:</strong>

              <p className="para">
                You agree that MnM may, in its sole discretion and without prior
                notice, terminate your access to this Platform or certain
                Services and/or block your future access to this Platform or
                certain Services, if MnM determines that you have violated these
                Terms of Use or other agreements or guidelines which may be
                associated with your use of this Platform. You also agree that
                any violation by you of these Terms of Use will constitute an
                unlawful and unfair business practice, and will cause
                irreparable harm to MnM, for which monetary damages would be
                inadequate, and you consent to MnM obtaining any injunctive or
                equitable relief that MnM deems necessary or appropriate in such
                circumstances. These remedies are in addition to any other
                remedies MnM may have at law or in equity.{" "}
              </p>
              <p className="para">
                You agree that MnM may, in its sole discretion and without prior
                notice, terminate your access to this Platform, for cause, which
                includes (but is not limited to): (i) requests by law
                enforcement or other government agencies, (ii) a request by you
                (self-initiated account deletions), (iii) discontinuance or
                material modification of this Platform or any service offered on
                or through this Platform, or (iv) unexpected technical issues or
                problems.{" "}
              </p>
              <p className="para">
                If MnM does take any legal action against you as a result of
                your violation of these Terms of Use, MnM will be entitled to
                recover from you, and you agree to pay, all reasonable legal
                costs of such action, in addition to any other relief granted to
                MnM. You agree that MnM will not be liable to you or to any
                third party for termination of your access to this Platform as a
                result of any violation of these Terms of Use.{" "}
              </p>
            </li>

            <li className="list_ol">
              <strong>General:</strong>

              <p className="para">
                Relationship between the Parties. There is no joint venture,
                partnership, agency or fiduciary relationship existing between
                you and MnM, and the parties do not intend to create any such
                relationship by this Terms of Use.{" "}
              </p>
            </li>
            <li className="list_ol">
              <strong>Invalidity.</strong>

              <p className="para">
                If any provision in or any part of this Terms of Use shall be
                found to be illegal or unenforceable under any enactment or rule
                of law then that provision or part shall to that extent be
                deemed not to form part of this Terms of Use and the remaining
                provisions shall continue in full force and effect.{" "}
              </p>
            </li>
            <li className="list_ol">
              <strong>Governing Law.</strong>

              <p>
                These Terms of Use shall be governed by and construed in
                accordance with laws of India, without giving effect to its
                conflicts of law principles. Any dispute arising out of or in
                connection with these Terms of Use shall be subject to the
                exclusive jurisdiction of courts located in Pune District,
                Maharashtra, INDA. Each party hereby irrevocably submits to the
                personal jurisdiction of such courts and waives any objection to
                the laying of venue in such courts.
              </p>
            </li>
            <li className="list_ol">
              <strong>Changes to Terms:</strong>
              <p className="para">
                MnM reserves the right to vary, amend, remove or add to the
                Terms of Use at any time. Such modifications shall be effective
                immediately. Your continued access and use of this Platform and
                Services following the posting of modifications to the Terms of
                Use shall constitute your acknowledgment and acceptance of such
                modifications. If, at any time, you do not wish to accept the
                Terms of Use, you must immediately cease to access or use this
                Platform and Services.
              </p>
            </li>
              <strong>Contact Us </strong>
              <p className="para">
                If You have any questions, doubts, clarifications or comments
                regarding this Terms of Use, please contact MarketsandMarkets at
                legal@marketsandmarkets.com
              </p>
			  <p className="para">
			  © 2024 - 2025 MarketsandMarkets Research Private Ltd. All rights reserved 
              </p>
			  <p className="para">
			  Terms of Use Effective from 1st March 2025 
              </p>
          </ol>
        </div>
      </section>
    </div>
  );
}
